import initShopifyClient from '../app/initializers/init-shopify-client';

export default ArticleGrid = async () => {
    // TODO: Add caching

    const tags = document.querySelectorAll('[data-tag-count]');

    if (tags.length === 0) return;

    const client = initShopifyClient('http://kodiakcakes.com', 'f0cd9a0824c3af9ac19fd37fc6cc0c40');

    if (!client) return;

    const tagData = []

	for (const tag of tags) {
        const alias = tag.dataset.tagCount.replaceAll(/[^\w]/g, '');
        const query = 'tag:' + tag.dataset.tagCount;

        tagData.push({
            el: tag,
            tag: tag.dataset.tagCount,
            count: 0,
            alias,
            query,
            graphql: `${alias}: articles(first: 250, query: "${query}") {
                edges {
                    node {
                      title
                    }
                }
            }
            `,
        })
	}

    const query = `
    query CountArticles {
        ${tagData.map(tag => tag.graphql).join('\n')}
    }
    `;

    const { data, errors } = await client.request(query, {});

    if (errors) {
        console.error(
            'Errors loading from the Storefront API: ',
            errors,
        );
        return false;
    }

    for (const tag of tagData) {
        const count = data[tag.alias].edges.length;
        tag.count = count;
        tag.el.innerHTML = count;
    }
};
